module.exports = __webpack_public_path__ + "static/media/POS_03_A.ebf9e365.png";